import * as tslib_1 from "tslib";
var RequisitionPerformanceReportController = /** @class */ (function () {
    /*@ngInject*/
    function RequisitionPerformanceReportController($filter, $rootScope, $timeout, stateManagementStorageService, requisitionPerformanceReportService, jobService, companyService, candidateService, dateTimeUtilityService, utilityService, alertsAndNotificationsService) {
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.stateManagementStorageService = stateManagementStorageService;
        this.reportService = requisitionPerformanceReportService;
        this.jobService = jobService;
        this.companyService = companyService;
        this.candidateService = candidateService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.utilityService = utilityService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.viewReportByFromState = "";
        this.savedFilters = null;
        this.companies = [];
        this.selectedCompanies = [];
        this.viewByOptions = [];
        this.selectedViewByOptions = [];
        this.clientOrBuList = [];
        this.selectedClientOrBuList = [];
        this.vendors = [];
        this.selectedVendors = [];
        this.roles = [];
        this.selectedRoles = [];
        this.workflowSteps = [];
        this.selectedWorkflowSteps = [];
        this.isHostCompany = this.companyService.isHostCompany();
        this.isCompaniesLoading = true;
        this.isClientsOrBusLoading = true;
        this.isVendorsLoading = true;
        this.isRolesLoading = true;
        this.isValidFilters = true;
        this.forInternalReport = false;
        this.showClickGetReportsMessage = false;
        this.showCorporateCandidates = false;
    }
    RequisitionPerformanceReportController.prototype.$onInit = function () {
        var _this = this;
        this.viewReportByFromState = this.viewReportBy;
        var savedFilters = this._getSavedFilters();
        if (savedFilters) {
            this.savedFilters = angular.copy(savedFilters);
            this.showCorporateCandidates = this.savedFilters.showCorporateCandidates == true;
        }
        this._setDateRangePicker(function () {
            _this._initFiltersAndGetReports();
        });
    };
    RequisitionPerformanceReportController.prototype.resetFilters = function () {
        this.showCorporateCandidates = false;
        this._clearFilters();
        this._initFiltersAndGetReports();
    };
    RequisitionPerformanceReportController.prototype._initFiltersAndGetReports = function () {
        var _this = this;
        this._setCompanyFilters();
        this._setReportLabelsByReportType();
        this._setGlobalFilters();
        this._setReportSections();
        this._setReasonCounts();
        if (this.isHostCompany) {
            this._getAllCompanies(function () {
                if (_this.savedFilters !== null) {
                    _this.selectedCompanyId = _this.savedFilters.companyId;
                    _this.selectedCompanyName = _this.savedFilters.companyName;
                }
                else {
                    _this.selectedCompanyId = _this.selectedCompanies[0].id;
                    _this.selectedCompanyName = _this.selectedCompanies[0].name;
                }
                _this._setViewByOptions(function () {
                    _this.viewReportBy = _this.selectedViewByOptions[0].id;
                    _this._setReportLabelsByReportType();
                    _this._getFilterValuesAndLoadReports(true);
                });
            });
        }
        else {
            this._clearFilters();
            this._getFilterValuesAndLoadReports(true);
        }
    };
    RequisitionPerformanceReportController.prototype._getSavedFilters = function () {
        switch (this.viewReportByFromState) {
            case "all":
                return this.stateManagementStorageService.getScreenState('requisitionPerformanceReportForAll');
                break;
            case "client":
                return this.stateManagementStorageService.getScreenState('requisitionPerformanceReportForClient');
                break;
            case "internalRecruitment":
                return this.stateManagementStorageService.getScreenState('requisitionPerformanceReportForInternalRecruitment');
                break;
            case "vendor":
                return this.stateManagementStorageService.getScreenState('requisitionPerformanceReportForVendor');
                break;
            default:
                break;
        }
    };
    RequisitionPerformanceReportController.prototype._setDateRangePicker = function (successCallback) {
        var _this = this;
        var vm = this;
        var start = moment().startOf('week');
        var end = moment().endOf('week');
        if (this.savedFilters !== null) {
            start = moment(this.savedFilters.startDateTime);
            end = moment(this.savedFilters.endDateTime);
        }
        $(document).ready(function () {
            //for popover on table header
            $('[data-toggle="popover"]').popover();
            var startDateOfThisQuarter = moment().quarter(moment().quarter()).startOf('quarter');
            var endDateOfThisQuarter = moment().quarter(moment().quarter()).endOf('quarter');
            var startDateOfLastQuarter = moment(startDateOfThisQuarter).subtract(1, 'Q');
            var endDateOfLastQuarter = moment(endDateOfThisQuarter).subtract(1, 'Q');
            var startDateOfYear = moment().startOf('year');
            $('#report-range').daterangepicker({
                startDate: start,
                endDate: end,
                // showDropdowns: true,
                opens: "right",
                cancelButtonClasses: 'btn-danger',
                ranges: {
                    'This Week': [moment().startOf('week'), moment().endOf('week')],
                    'Last Week': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                    'This Quarter': [startDateOfThisQuarter, endDateOfThisQuarter],
                    'Last Quarter': [startDateOfLastQuarter, endDateOfLastQuarter],
                    'Year to Date': [startDateOfYear, moment()]
                },
                locale: {
                    format: "MMMM DD, YYYY",
                    separator: " - "
                }
            }, onDateRangeChange);
            onDateRangeChange(start, end, true);
            _this.startDateTime = _this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(start));
            _this.endDateTime = _this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(end).setHours(23, 59, 59, 999));
            successCallback();
            function onDateRangeChange(start, end, init) {
                vm.onDateRangeChange(start, end, init);
            }
        });
    };
    RequisitionPerformanceReportController.prototype.onDateRangeChange = function (start, end, init) {
        $('#report-range span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
        this.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(start));
        this.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(end).setHours(23, 59, 59, 999));
        if (init !== true) { //to avoid initial api call
            this.getFilterValues();
        }
    };
    RequisitionPerformanceReportController.prototype._setCompanyFilters = function () {
        if (this.savedFilters) {
            this.isStaffingCompany = this.savedFilters.isStaffingCompany;
            this.viewReportBy = this.savedFilters.viewReportBy;
            this.selectedCompanyId = this.savedFilters.companyId;
            this.selectedCompanyName = this.savedFilters.companyName;
        }
        else {
            if (this.isHostCompany) {
                this.isStaffingCompany = true;
                this.viewReportBy = 'client';
            }
            else {
                this.isStaffingCompany = this.companyService.isStaffingCompany();
                this.selectedCompanyId = this.$rootScope.userDetails.company.companyId;
                this.selectedCompanyName = this.$rootScope.userDetails.company.companyName;
            }
        }
    };
    RequisitionPerformanceReportController.prototype._setReportLabelsByReportType = function () {
        this.vendorsOrClientsOrBusLabel = "";
        if (this.viewReportBy == 'internalRecruitment') {
            this.vendorsOrClientsOrBusLabel = "BU";
            this.forInternalReport = true;
        }
        else if (this.viewReportBy == 'client') {
            this.vendorsOrClientsOrBusLabel = "Client";
            this.forInternalReport = true;
        }
        else if (this.viewReportBy == 'vendor') {
            this.vendorsOrClientsOrBusLabel = "Vendor";
            this.forInternalReport = false;
        }
        else {
            this.vendorsOrClientsOrBusLabel = "All";
        }
        this.reportDataTypes = ["All Data including Totals", "Only " + this.vendorsOrClientsOrBusLabel + " Totals"];
        this.selectedReportDataType = "All Data including Totals";
    };
    RequisitionPerformanceReportController.prototype._setGlobalFilters = function () {
        this.reportPeriods = this.reportService.getReportPeriods();
        ;
        this.reportTypes = ["Graph", "Table"];
        if (this.savedFilters) {
            this.selectedReportType = this.savedFilters.selectedReportType;
            this.selectedReportDataType = this.savedFilters.selectedReportDataType;
        }
        else {
            this.selectedReportType = "Graph";
            this.selectedReportDataType = "All Data including Totals";
        }
    };
    RequisitionPerformanceReportController.prototype._setReportSections = function () {
        this.reportSections = this.reportService.getReportSections();
    };
    RequisitionPerformanceReportController.prototype._setReasonCounts = function () {
        var reasonCounts = [{ name: 'Top 10', value: '10', selected: true }, { name: 'All', value: 'all' }];
        this.releaseReasonCounts = angular.copy(reasonCounts);
        this.notInterestedReasonCounts = angular.copy(reasonCounts);
    };
    RequisitionPerformanceReportController.prototype._getAllCompanies = function (successCallback) {
        if (this.isStaffingCompany) {
            this._getAllStaffingCompanies(function () {
                if (successCallback) {
                    successCallback();
                }
            });
        }
        else {
            this._getAllCorporateCompanies(function () {
                if (successCallback) {
                    successCallback();
                }
            });
        }
    };
    RequisitionPerformanceReportController.prototype.getFilterValues = function () {
        var _this = this;
        this._getAllClientsOrBus(function () {
            if (_this.isStaffingCompany) {
                _this._getAllRoles();
            }
            else if (_this.viewReportBy === 'vendor') {
                _this._getAllVendors(function () {
                    _this._getAllRoles();
                }, true);
            }
            else {
                _this._getAllRoles();
            }
        }, true);
    };
    RequisitionPerformanceReportController.prototype._getFilterValuesAndLoadReports = function (isInit) {
        var _this = this;
        this._getAllClientsOrBus(function () {
            if (_this.isStaffingCompany) {
                _this._getAllRoles(function () {
                    _this._getDataAndInitializeReports(isInit);
                }, true);
            }
            else if (_this.viewReportBy === 'vendor') {
                _this._getAllVendors(function () {
                    _this._getAllRoles(function () {
                        _this._getDataAndInitializeReports(isInit);
                    }, true);
                }, true);
            }
            else {
                _this._getAllRoles(function () {
                    _this._getDataAndInitializeReports(isInit);
                }, true);
            }
        }, true);
    };
    RequisitionPerformanceReportController.prototype._getAllStaffingCompanies = function (successCallback) {
        var _this = this;
        this.isCompaniesLoading = true;
        var companiesFilter = {
            startDate: null,
            endDate: null
        };
        this.companyService.getAllStaffingCompaniesForReport(companiesFilter, function (data) {
            _this._setCompanies(data);
            _this.isCompaniesLoading = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionPerformanceReportController.prototype._getAllCorporateCompanies = function (successCallback) {
        var _this = this;
        this.isCompaniesLoading = true;
        var companiesFilter = {
            startDate: null,
            endDate: null
        };
        this.companyService.getAllCorporateCompaniesForReport(companiesFilter, function (data) {
            _this._setCompanies(data);
            _this.isCompaniesLoading = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionPerformanceReportController.prototype._setCompanies = function (companies) {
        var _this = this;
        this.companies = [];
        for (var companyId in companies) {
            this.companies.push({ id: companyId, name: companies[companyId], selectedDisplayName: this.$filter('displayOnMultiSelectFilter')(companies[companyId]) });
        }
        var selectedCompany = this.companies[0];
        if (this.savedFilters !== null) {
            selectedCompany = this.companies.find(function (company) { return company.id == _this.savedFilters.companyId; });
        }
        selectedCompany.selected = true;
        this.selectedCompanies = [];
        this.selectedCompanies.push(selectedCompany);
    };
    RequisitionPerformanceReportController.prototype._setViewByOptions = function (successCallback) {
        var _this = this;
        if (this.isStaffingCompany) {
            this.viewByOptions = [
                { id: 'client', name: 'Client' }
            ];
        }
        else {
            this.viewByOptions = [
                { id: 'vendor', name: 'Vendor' },
                { id: 'internalRecruitment', name: 'Internal Recruitment' }
            ];
        }
        this.selectedViewByOptions = [];
        var selectedViewByOption = this.viewByOptions[0];
        if (this.savedFilters !== null) {
            var selectedViewByOption_1 = this.viewByOptions.find(function (option) { return option.id == _this.savedFilters.viewReportBy; });
        }
        selectedViewByOption.selected = true;
        this.selectedViewByOptions.push(selectedViewByOption);
        if (successCallback) {
            successCallback();
        }
    };
    RequisitionPerformanceReportController.prototype._getAllClientsOrBus = function (successCallback, isInit) {
        var _this = this;
        this.isClientsOrBusLoading = true;
        var clientsOrBusFilter = {
            companyId: this.selectedCompanyId,
            startDate: this.startDateTime,
            endDate: this.endDateTime
        };
        this.companyService.getAllClientsOrBusByScope(clientsOrBusFilter, function (data) {
            _this._setClientOrBuList(data, isInit);
            _this.isClientsOrBusLoading = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionPerformanceReportController.prototype._setClientOrBuList = function (clientsOrBus, isInit) {
        var _this = this;
        var e_1, _a, e_2, _b;
        this.clientOrBuList = [];
        try {
            for (var clientsOrBus_1 = tslib_1.__values(clientsOrBus), clientsOrBus_1_1 = clientsOrBus_1.next(); !clientsOrBus_1_1.done; clientsOrBus_1_1 = clientsOrBus_1.next()) {
                var clientOrBu = clientsOrBus_1_1.value;
                var name_1 = this._getFilterDisplayName(clientOrBu.name, clientOrBu.inCurrentScope, false);
                var displayName = this._getFilterDisplayName(clientOrBu.name, clientOrBu.inCurrentScope, true);
                this.clientOrBuList.push({ id: clientOrBu.id, name: name_1, selectedDisplayName: displayName, inCurrentScope: clientOrBu.inCurrentScope, unFormattedName: clientOrBu.name });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (clientsOrBus_1_1 && !clientsOrBus_1_1.done && (_a = clientsOrBus_1.return)) _a.call(clientsOrBus_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (this.savedFilters !== null) {
            this.selectedClientOrBuList = this.clientOrBuList.filter(function (clientOrBu) { return _this.savedFilters.clienOrBUIds.some(function (clientOrBuId) { return clientOrBuId == clientOrBu.id; }); });
        }
        else {
            var alreadySelectedClientOrBuList = this.clientOrBuList.filter(function (clientOrBu) { return _this.selectedClientOrBuList.some(function (selected) { return clientOrBu.id == selected.id; }); });
            if (alreadySelectedClientOrBuList.length == 0) {
                this.selectedClientOrBuList = tslib_1.__spread(this.clientOrBuList);
            }
            else {
                this.selectedClientOrBuList = tslib_1.__spread(alreadySelectedClientOrBuList);
            }
        }
        try {
            for (var _c = tslib_1.__values(this.selectedClientOrBuList), _d = _c.next(); !_d.done; _d = _c.next()) {
                var clientOrBu = _d.value;
                clientOrBu.ticked = true;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    RequisitionPerformanceReportController.prototype._getFilterDisplayName = function (name, inCurrentScope, withLengthFormatting) {
        var formattedName = "";
        if (withLengthFormatting) {
            if (name.length > 30) {
                formattedName = name.substring(0, 30) + "...";
            }
            else {
                formattedName = name;
            }
        }
        else {
            formattedName = name;
        }
        if (inCurrentScope) {
            return formattedName;
        }
        else {
            return '<span class="opacity-half">' + formattedName + '</span>';
        }
    };
    RequisitionPerformanceReportController.prototype._getAllVendors = function (successCallback, isInit) {
        var _this = this;
        this.isVendorsLoading = true;
        var clientOrBuIds = this._getSelectedClientOrBuIds();
        var vendorsFilter = {
            buIds: clientOrBuIds,
            startDate: this.startDateTime,
            endDate: this.endDateTime
        };
        this.companyService.getAllVendorsByScope(vendorsFilter, this.selectedCompanyId, function (data) {
            _this._setVendors(data, isInit);
            _this.isVendorsLoading = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionPerformanceReportController.prototype._getSelectedClientOrBuIds = function () {
        return this.selectedClientOrBuList.map(function (bu) {
            return bu.id;
        });
    };
    RequisitionPerformanceReportController.prototype._setVendors = function (fetchedVendors, isInit) {
        var _this = this;
        var e_3, _a, e_4, _b;
        this.vendors = [];
        try {
            for (var fetchedVendors_1 = tslib_1.__values(fetchedVendors), fetchedVendors_1_1 = fetchedVendors_1.next(); !fetchedVendors_1_1.done; fetchedVendors_1_1 = fetchedVendors_1.next()) {
                var vendor = fetchedVendors_1_1.value;
                var vendorObj = {
                    id: vendor.id,
                    name: vendor.name,
                    selectedDisplayName: this.$filter('displayOnMultiSelectFilter')(vendor.name),
                    unFormattedName: vendor.name,
                    buIds: vendor.buIds
                };
                this.vendors.push(vendorObj);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (fetchedVendors_1_1 && !fetchedVendors_1_1.done && (_a = fetchedVendors_1.return)) _a.call(fetchedVendors_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        if (this.savedFilters !== null) {
            this.selectedVendors = this.vendors.filter(function (vendor) { return _this.savedFilters.vendorIds.some(function (vendorId) { return vendorId == vendor.id; }); });
        }
        else {
            var alreadySelectedVendors = this.vendors.filter(function (vendor) { return _this.selectedVendors.some(function (selected) { return vendor.id == selected.id; }); });
            if (alreadySelectedVendors.length == 0) {
                this.selectedVendors = tslib_1.__spread(this.vendors);
            }
            else {
                this.selectedVendors = tslib_1.__spread(alreadySelectedVendors);
            }
        }
        try {
            for (var _c = tslib_1.__values(this.selectedVendors), _d = _c.next(); !_d.done; _d = _c.next()) {
                var vendor = _d.value;
                vendor.ticked = true;
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    RequisitionPerformanceReportController.prototype._selectAllVendorsOfNewlySelectClientsOrBus = function () {
        var _this = this;
        this.clientOrBuList.forEach(function (clientOrBu) {
            if (clientOrBu.ticked) {
                _this.vendors.forEach(function (vendor) {
                    if (vendor.buIds.includes(clientOrBu.id)) {
                        vendor.ticked = true;
                        if (!_this.selectedVendors.some(function (selectedVendor) { return selectedVendor.id === vendor.id; })) {
                            _this.selectedVendors.push(vendor);
                        }
                    }
                });
            }
        });
    };
    RequisitionPerformanceReportController.prototype._getAllRoles = function (successCallback, isInit) {
        var _this = this;
        this.isRolesLoading = true;
        var clientOrBuIds = this._getSelectedClientOrBuIds();
        var vendorIds = this._getSelectedVendorIds();
        var filters = {
            companyId: this.selectedCompanyId,
            forInternalReport: this.forInternalReport,
            clientOrbuIds: clientOrBuIds,
            vendorIds: vendorIds,
            startDate: this.startDateTime,
            endDate: this.endDateTime
        };
        this.jobService.getAllJobsByScope(filters, function (data) {
            _this.fetchedRoles = data;
            _this._setRoles(data, isInit);
            _this.savedFilters = null;
            _this.isRolesLoading = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    RequisitionPerformanceReportController.prototype._getSelectedVendorIds = function () {
        return this.selectedVendors.map(function (vendor) {
            return vendor.id;
        });
    };
    RequisitionPerformanceReportController.prototype._setRoles = function (fetchedRoles, isInit) {
        var _this = this;
        var e_5, _a, e_6, _b;
        var previousRoles = tslib_1.__spread(this.roles);
        this.roles = [];
        try {
            for (var fetchedRoles_1 = tslib_1.__values(fetchedRoles), fetchedRoles_1_1 = fetchedRoles_1.next(); !fetchedRoles_1_1.done; fetchedRoles_1_1 = fetchedRoles_1.next()) {
                var role = fetchedRoles_1_1.value;
                var name_2 = this._getFilterDisplayName(role.requisitionNumber, role.inCurrentScope, false);
                var displayName = this._getFilterDisplayName(role.requisitionNumber + ' ' + role.roleName, role.inCurrentScope, true);
                var fullName = this._getFilterDisplayName(role.requisitionNumber + ' ' + role.roleName, role.inCurrentScope, false);
                var fullNameWithIcon = fullName;
                if (role.sharedRequisition) {
                    fullNameWithIcon = "<i class=\"fas fa-share-alt\"></i> " + fullNameWithIcon;
                }
                else {
                    fullNameWithIcon = "&nbsp;&nbsp;&nbsp;&nbsp;" + fullNameWithIcon;
                }
                var icon = role.sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '';
                var roleObj = {
                    id: role.id,
                    name: name_2,
                    displayName: displayName,
                    icon: icon,
                    selectedDisplayName: displayName,
                    fullName: fullName,
                    fullNameWithIcon: fullNameWithIcon,
                    inCurrentScope: role.inCurrentScope,
                    unFormattedName: role.requisitionNumber,
                    clientOrBuId: role.clientOrBuId,
                    vendorId: role.vendorId
                };
                this.roles.push(roleObj);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (fetchedRoles_1_1 && !fetchedRoles_1_1.done && (_a = fetchedRoles_1.return)) _a.call(fetchedRoles_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        if (this.savedFilters !== null) {
            this.selectedRoles = this.roles.filter(function (role) { return _this.savedFilters.roles.some(function (roleId) { return roleId == role.id; }); });
        }
        else {
            var alreadySelectedRoles = this.roles.filter(function (role) { return _this.selectedRoles.some(function (selected) { return role.id == selected.id; }); });
            if (this._hasNoRolesBeenSelectedPreviously(alreadySelectedRoles) || this._hasAllRolesBeenSelectedPreviouslyAndNewRolesAreToBeSelected(alreadySelectedRoles, previousRoles)) {
                this.selectedRoles = tslib_1.__spread(this.roles);
                this.onRoleChange();
            }
            else {
                if (this.selectedRoles.length !== alreadySelectedRoles.length) {
                    this.onRoleChange();
                }
                this.selectedRoles = tslib_1.__spread(alreadySelectedRoles);
            }
        }
        try {
            for (var _c = tslib_1.__values(this.selectedRoles), _d = _c.next(); !_d.done; _d = _c.next()) {
                var role = _d.value;
                role.ticked = true;
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            }
            finally { if (e_6) throw e_6.error; }
        }
    };
    RequisitionPerformanceReportController.prototype._hasNoRolesBeenSelectedPreviously = function (alreadySelectedRoles) {
        return alreadySelectedRoles.length == 0;
    };
    RequisitionPerformanceReportController.prototype._hasAllRolesBeenSelectedPreviouslyAndNewRolesAreToBeSelected = function (alreadySelectedRoles, previousRoles) {
        return alreadySelectedRoles.length == previousRoles.length && this.roles.length > alreadySelectedRoles.length;
    };
    RequisitionPerformanceReportController.prototype._selectAllRolesOfNewlySelectedClientsOrBusAndVendors = function () {
        var _this = this;
        this.clientOrBuList.forEach(function (clientOrBu) {
            if (clientOrBu.ticked) {
                _this.vendors.forEach(function (vendor) {
                    if (vendor.ticked && !_this.selectedRoles.some(function (role) { return role.clientOrBuId === clientOrBu.id && role.vendorId === vendor.id; })) {
                        _this.roles.forEach(function (role) {
                            if (role.clientOrBuId == clientOrBu.id && role.vendorId == vendor.id) {
                                role.ticked = true;
                                _this.selectedRoles.push(role);
                            }
                        });
                    }
                });
            }
        });
    };
    RequisitionPerformanceReportController.prototype._selectAllRolesOfNewlySelectedClientsOrBus = function () {
        var _this = this;
        this.clientOrBuList.forEach(function (clientOrBu) {
            if (clientOrBu.ticked && !_this.selectedRoles.some(function (role) { return role.clientOrBuId === clientOrBu.id; })) {
                _this.roles.forEach(function (role) {
                    if (role.clientOrBuId == clientOrBu.id) {
                        role.ticked = true;
                        _this.selectedRoles.push(role);
                    }
                });
            }
        });
    };
    RequisitionPerformanceReportController.prototype.getReportsAndSetReports = function () {
        var _this = this;
        this._getReportData(function () {
            $(document).ready(function () {
                _this._initializeTables();
                _this._setWorkflowStepsVisibilityFilter();
                _this._setGraphs();
            });
        });
    };
    RequisitionPerformanceReportController.prototype._getDataAndInitializeReports = function (isInit) {
        var _this = this;
        this._getReportData(function () {
            $(document).ready(function () {
                _this._initializeTables(isInit);
                _this._setWorkflowStepsVisibilityFilter();
                _this._setGraphs();
            });
        });
    };
    RequisitionPerformanceReportController.prototype._getReportData = function (successCallback) {
        var _this = this;
        this.showClickGetReportsMessage = false;
        this.reportSections.forEach(function (section) {
            section.isGraphLoading = true;
        });
        var clientOrBuIds = this._getSelectedClientOrBuIds();
        var vendorIds = this._getSelectedVendorIds();
        var roleIds = this._getSelectedRoleIds();
        if (roleIds.length == 0 || this.viewReportBy == 'all') {
            this.isValidFilters = false;
            this.invalidFiltersMessage = "Please select roles to filter";
        }
        else {
            this.utilityService.showLoadingModal("Loading Reports");
            this.isValidFilters = true;
            var filters = {
                companyId: this.selectedCompanyId,
                companyName: this.selectedCompanyName,
                roles: roleIds,
                clienOrBUIds: clientOrBuIds,
                startDateTime: this.startDateTime,
                endDateTime: this.endDateTime,
                forInternalReport: this.forInternalReport,
                vendorIds: vendorIds,
                jobByScopeResponseDTOs: this.fetchedRoles,
                //for saving filters
                isStaffingCompany: this.isStaffingCompany,
                selectedReportType: this.selectedReportType,
                selectedReportDataType: this.selectedReportDataType,
                viewReportBy: this.viewReportBy,
                showCorporateCandidates: this.showCorporateCandidates
            };
            this._setSavedFilters(filters);
            this.companyService.getCompanyReports(filters, function (data) {
                // data = this.reportService.getDummyData();
                _this._massageReportData(data);
                _this.utilityService.hideLoadingModal();
                if (successCallback) {
                    successCallback();
                }
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
    };
    RequisitionPerformanceReportController.prototype._setSavedFilters = function (filters) {
        switch (this.viewReportByFromState) {
            case "all":
                this.stateManagementStorageService.setScreenState('requisitionPerformanceReportForAll', filters);
                break;
            case "client":
                this.stateManagementStorageService.setScreenState('requisitionPerformanceReportForClient', filters);
                break;
            case "internalRecruitment":
                this.stateManagementStorageService.setScreenState('requisitionPerformanceReportForInternalRecruitment', filters);
                break;
            case "vendor":
                this.stateManagementStorageService.setScreenState('requisitionPerformanceReportForVendor', filters);
                break;
            default:
                break;
        }
    };
    RequisitionPerformanceReportController.prototype._massageReportData = function (fetchedData) {
        this.reportData = this.reportService.getMassagedReportData(fetchedData, this.viewReportBy, this.selectedCompanyName);
    };
    RequisitionPerformanceReportController.prototype._getSelectedRoleIds = function () {
        return this.selectedRoles.map(function (role) {
            return role.id;
        });
    };
    //Table
    RequisitionPerformanceReportController.prototype._setWorkflowStepsVisibilityFilter = function () {
        this.workflowSteps = [
            { name: "Recruiter Screening", fields: ["inRecruiterScreening", "recruiterScreeningSkipped", "recruiterScreeningDone", "recruiterScreeningPassed", "recruiterScreeningFailed"], ticked: true },
            { name: "Tech Assessment", fields: ["techAssessmentCancelled", "techAssessmentSent", "techAssessmentTestLeft", "techAssessmentExpired", "techAssessmentNotYetSend", "techAssessmentSendFailed", "techAssessmentSuspended", "techAssessmentTerminated", "inTechAssessment", "attemptedCandidatesCount", "techAssessmentAttemptCount", "techAssessmentSkipped", "techAssessmentDone", "techAssessmentPassed", "techAssessmentFailed", "techAssessmentCompleted"], ticked: true },
            { name: "Value Assessment", fields: ["inValueAssessment", "valueAssessmentSkipped", "valueAssessmentDone", "valueAssessmentPassed", "valueAssessmentFailed"], ticked: true },
            { name: "Phone Screen", fields: ["inPhoneScreen", "phoneScreenSkipped", "phoneScreenScheduled", "phoneScreenDone", "phoneScreenPassed", "phoneScreenFailed"], ticked: true },
            { name: "Interview", fields: ["inInterview", "interviewScheduled", "interviewDone", "interviewPassed", "interviewFailed"], ticked: true },
            { name: "Filled", fields: ["filled"], ticked: true },
            { name: "Hired", fields: ["hired"], ticked: true },
            { name: "Released", fields: ["released"], ticked: true },
            { name: "Not Interested", fields: ["notInterested"], ticked: true }
        ];
    };
    RequisitionPerformanceReportController.prototype._initializeTables = function (isInit) {
        var _this = this;
        angular.forEach(this.reportSections, function (section, key) {
            _this._initializeTable(section.sectionNumber, isInit);
        });
    };
    RequisitionPerformanceReportController.prototype._initializeTable = function (sectionNumber, isInit) {
        var reportData = angular.copy(this.reportData);
        var isAllData = true;
        if (this.selectedReportDataType !== "All Data including Totals") {
            if (this.showCorporateCandidates) {
                reportData.table = angular.copy(this.reportData.table.withoutTotalWithCorporateCandidates);
            }
            else {
                reportData.table = angular.copy(this.reportData.table.withoutTotal);
            }
            isAllData = false;
        }
        else if (this.showCorporateCandidates) {
            reportData.table = angular.copy(this.reportData.table.withCorporateCandidates);
        }
        if (isInit || Object.keys(this.reportSections[sectionNumber].table).length === 0) {
            var gridOptions = this.reportService.getGridOptions(sectionNumber, this.vendorsOrClientsOrBusLabel, reportData, isAllData, this.clientOrBuList);
            this.reportSections[sectionNumber].table.gridOptions = gridOptions.gridOptions;
            this.reportSections[sectionNumber].table.gridOptionsFooter = gridOptions.gridOptionsFooter;
            console.log("initialize report");
            this.reportSections[sectionNumber].isTableLoading = false;
        }
        else {
            var gridId = '#grid-' + sectionNumber;
            var rowData = this.reportService.getRowData(sectionNumber, reportData);
            var footerRowData = this.reportService.getFooterRowData(sectionNumber, reportData, isAllData);
            var columnDefs = this.reportService.getColumnDefs(sectionNumber, this.vendorsOrClientsOrBusLabel, reportData, isAllData);
            this.reportSections[sectionNumber].table.gridOptions.api.setRowData(rowData);
            this.reportSections[sectionNumber].table.gridOptions.api.setPinnedBottomRowData(footerRowData);
            this.reportSections[sectionNumber].table.gridOptions.api.setColumnDefs(columnDefs);
            if (rowData.length < 10) {
                this.reportSections[sectionNumber].table.gridOptions.api.setDomLayout('autoHeight');
                document.querySelector(gridId).style.height = '';
            }
            else {
                this.reportSections[sectionNumber].table.gridOptions.api.setDomLayout('normal');
                // when auto height is off, the grid ahs a fixed height, and then the grid
                // will provide scrollbars if the data does not fit into it.
                document.querySelector(gridId).style.height = '400px';
            }
        }
    };
    RequisitionPerformanceReportController.prototype.getTableHeight = function (reportSection) {
        var tableName = reportSection.name;
        if (reportSection.table.gridOptions.rowData.length < 10) {
            return {};
        }
        // if(tableName === 'Tech Assessments Scores'){
        //     return { "height": "400px", "width": "90%" };
        // } else {
        return { "height": "400px", "width": "100%" };
        // }
        // if(tableName == 'Workflow Steps') {
        // } else if(tableName == 'Job Matches Scores') {
        //     return { "height": "400px", "width": "90%" };
        // } else {
        //     return { "height": "400px", "width": "80%" };
        // }
    };
    RequisitionPerformanceReportController.prototype.autoSizeAll = function (sectionNumber, skipHeader) {
        var section = this.reportSections[sectionNumber];
        var allColumnIds = [];
        console.log(section.table.gridOptions);
        if (!_.isEmpty(section.table)) {
            section.table.gridOptions.columnApi.getAllColumns().forEach(function (column) {
                allColumnIds.push(column.colId);
            });
            section.table.gridOptions.columnApi.autoSizeColumns(allColumnIds, false);
        }
    };
    RequisitionPerformanceReportController.prototype.onFirstDataRendered = function () {
        angular.forEach(this.reportSections, function (section, key) {
            var allColumnIds = [];
            console.log(section.table.gridOptions);
            if (!_.isEmpty(section.table)) {
                section.table.gridOptions.columnApi.getAllColumns().forEach(function (column) {
                    allColumnIds.push(column.colId);
                });
                section.table.gridOptions.columnApi.autoSizeColumns(allColumnIds, false);
            }
        });
    };
    RequisitionPerformanceReportController.prototype.onWorkflowStepClick = function () {
        var _this = this;
        angular.forEach(this.workflowSteps, function (step, key) {
            angular.forEach(step.fields, function (field, index) {
                _this.reportSections[0].table.gridOptions.columnApi.setColumnVisible(field, step.ticked);
            });
        });
    };
    //Set Graphs
    RequisitionPerformanceReportController.prototype._setGraphs = function () {
        var _this = this;
        angular.forEach(this.reportSections, function (section, key) {
            _this._setGraph(section.sectionNumber);
            section.isGraphLoading = false;
            angular.forEach(section.subSections, function (subSec, key) {
                _this._setGraph(subSec.sectionNumber);
                subSec.isGraphLoading = false;
            });
        });
    };
    RequisitionPerformanceReportController.prototype._setGraph = function (sectionNumber) {
        var graphData = this.showCorporateCandidates ? this.reportData.graph.withCorporate : this.reportData.graph;
        var graphSettings = this.reportService.getGraphSettings(sectionNumber, graphData);
        if (sectionNumber < 5) {
            this.reportSections[sectionNumber].graph.labels = graphSettings.labels;
            this.reportSections[sectionNumber].graph.data = graphSettings.data;
            this.reportSections[sectionNumber].graph.options = graphSettings.options;
            this.reportSections[sectionNumber].graph.series = graphSettings.series;
            this.reportSections[sectionNumber].graph.colors = graphSettings.colors;
        }
        else if (sectionNumber == 5) {
            this.reportSections[3].subSections[0].graph.labels = graphSettings.labels;
            this.reportSections[3].subSections[0].graph.data = graphSettings.data;
            this.reportSections[3].subSections[0].graph.options = graphSettings.options;
            this.reportSections[3].subSections[0].graph.series = graphSettings.series;
            this.reportSections[3].subSections[0].graph.colors = graphSettings.colors;
        }
        else if (sectionNumber == 6) {
            this.reportSections[4].subSections[0].graph.labels = graphSettings.labels;
            this.reportSections[4].subSections[0].graph.data = graphSettings.data;
            this.reportSections[4].subSections[0].graph.options = graphSettings.options;
            this.reportSections[4].subSections[0].graph.series = graphSettings.series;
            this.reportSections[4].subSections[0].graph.colors = graphSettings.colors;
        }
    };
    RequisitionPerformanceReportController.prototype.toggleCompanyType = function (isStaffingCompany) {
        var _this = this;
        this.isStaffingCompany = isStaffingCompany;
        this._getAllCompanies(function () {
            _this.selectedCompanyId = _this.selectedCompanies[0].id;
            _this.selectedCompanyName = _this.selectedCompanies[0].name;
            _this._setViewByOptions(function () {
                _this.viewReportBy = _this.selectedViewByOptions[0].id;
                _this._setReportLabelsByReportType();
                _this._clearFilters();
                _this.getFilterValues(false);
            });
        });
    };
    RequisitionPerformanceReportController.prototype.onCompanySelected = function () {
        if (this.selectedCompanies.length > 0) {
            this.selectedCompanyId = this.selectedCompanies[0].id;
            this.selectedCompanyName = this.selectedCompanies[0].name;
            this._clearFilters();
            this.getFilterValues();
        }
        else {
            this.selectedCompanyId = null;
            this.selectedCompanyName = null;
        }
    };
    RequisitionPerformanceReportController.prototype._clearFilters = function () {
        this.clientOrBuList = [];
        this.selectedClientOrBuList = [];
        this.vendors = [];
        this.selectedVendors = [];
        this.roles = [];
        this.selectedRoles = [];
    };
    RequisitionPerformanceReportController.prototype.onViewBySelected = function () {
        this.viewReportBy = this.selectedViewByOptions[0].id;
        this._setReportLabelsByReportType();
        this._clearFilters();
        this.getFilterValues();
    };
    RequisitionPerformanceReportController.prototype.toggleReportType = function (reportType) {
        var _this = this;
        this.selectedReportType = reportType;
        if (reportType == "Graph") {
            this.$timeout(function () {
                _this._setGraphs();
            }, 100);
        }
    };
    RequisitionPerformanceReportController.prototype.toggleReportDataType = function (reportDataType) {
        this.selectedReportDataType = reportDataType;
        this._setWorkflowStepsVisibilityFilter();
        this._initializeTables();
    };
    RequisitionPerformanceReportController.prototype.toggleShowCorporateCandidates = function () {
        var _this = this;
        if (this.savedFilters !== null) {
            this.savedFilter.showCorporateCandidates = this.showCorporateCandidates;
        }
        this.$timeout(function () {
            _this._setWorkflowStepsVisibilityFilter();
            _this._initializeTables();
            _this._setGraphs();
        }, 100);
    };
    RequisitionPerformanceReportController.prototype.selectRemoveAll = function (filterName, action) {
        if (action == 'selectAll') {
            switch (filterName) {
                case 'clientsOrBus':
                    this.selectedClientOrBuList = tslib_1.__spread(this.clientOrBuList);
                    this.selectedClientOrBuList.forEach(function (clientOrBu) {
                        clientOrBu.ticked = true;
                    });
                    this.onClientOrBuChange();
                    break;
                case 'vendors':
                    this.selectedVendors = tslib_1.__spread(this.vendors);
                    this.selectedVendors.forEach(function (vendor) {
                        vendor.ticked = true;
                    });
                    this.onVendorChange();
                    break;
                case 'roles':
                    this.selectedRoles = tslib_1.__spread(this.roles);
                    this.selectedRoles.forEach(function (role) {
                        role.ticked = true;
                    });
                    this.onRoleChange();
                    break;
                default:
                    //do nothing
                    break;
            }
        }
        else if (action == 'removeAll') {
            switch (filterName) {
                case 'clientsOrBus':
                    this.selectedClientOrBuList = [];
                    this.onClientOrBuChange();
                    break;
                case 'vendors':
                    this.selectedVendors = [];
                    this.onVendorChange();
                    break;
                case 'roles':
                    this.selectedRoles = [];
                    this.onRoleChange();
                    break;
                default:
                    //do nothing
                    break;
            }
        }
    };
    RequisitionPerformanceReportController.prototype.onClientOrBuChange = function () {
        var _this = this;
        if (this.isStaffingCompany) {
            this._getAllRoles();
        }
        else if (this.viewReportBy === 'vendor') {
            this._getAllVendors(function () {
                _this._getAllRoles();
            });
        }
        else {
            this._getAllRoles();
        }
    };
    RequisitionPerformanceReportController.prototype.onVendorChange = function () {
        this._getAllRoles();
    };
    RequisitionPerformanceReportController.prototype.onRoleChange = function () {
        this.showClickGetReportsMessage = true;
    };
    RequisitionPerformanceReportController.prototype.resetTable = function (sectionNumber) {
        var section = this.reportSections[sectionNumber];
        if (sectionNumber == 0) {
            this._setWorkflowStepsVisibilityFilter();
        }
        var reportData = angular.copy(this.reportData);
        var isAllData = true;
        if (this.selectedReportDataType !== "All Data including Totals") {
            if (this.showCorporateCandidates) {
                reportData.table = angular.copy(this.reportData.table.withoutTotalWithCorporateCandidates);
            }
            else {
                reportData.table = angular.copy(this.reportData.table.withoutTotal);
            }
        }
        else if (this.showCorporateCandidates) {
            reportData.table = angular.copy(this.reportData.table.withCorporateCandidates);
        }
        var columnDefs = this.reportService.getColumnDefs(sectionNumber, this.vendorsOrClientsOrBusLabel, reportData, isAllData);
        section.table.gridOptions.api.setColumnDefs(columnDefs);
        // section.table.gridOptions.columnApi.resetColumnState();
    };
    RequisitionPerformanceReportController.prototype.$onDestroy = function () {
    };
    return RequisitionPerformanceReportController;
}());
RequisitionPerformanceReportController.$inject = ['$filter', '$rootScope', '$timeout', 'stateManagementStorageService', 'requisitionPerformanceReportService', 'jobService', 'companyService', 'candidateService', 'dateTimeUtilityService', 'utilityService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './requisition-performance-report.html';
import * as TEMPLATE from 'raw-loader!./requisition-performance-report.html';
export var RequisitionPerformanceReportComponent = {
    selector: 'requisitionPerformanceReport',
    component: {
        bindings: {
            viewReportBy: '<'
        },
        controller: RequisitionPerformanceReportController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/reports/requisitionPerformanceReport/requisitionPerformanceReport/requisition-performance-report.html'
    }
};
//# sourceMappingURL=requisition-performance-report.component.js.map